/**
 * configure WebPack public path
 * @see https://webpack.js.org/guides/public-path/
 * @see https://stackoverflow.com/a/31796977
 */

const ORDER_URL_PREFIX = 'bestellen.';

// Can be removed after upgrading to webpack 5 - and publicPath is set to 'auto' in webpack.mix.js.
if (window.location.href.indexOf(ORDER_URL_PREFIX) > -1) { // This is currently done to have a proper public path for the eactive shop environment
    __webpack_public_path__ = `${window.location.origin.replace(ORDER_URL_PREFIX, '')}/wp-content/themes/${themeName}/dist/`;

    /**
     * Icons are not working if the domain is included in the svg use tag, which happens on the cart page.
     * The best way would be if eActive fixed this, but that would be a lot more expensive than this fix.
     */
    ready().then(function () {
        $('svg use').each((_i, obj) => {
            let href = jQuery(obj).attr('xlink:href');
            let splitHref = href.split('#');
            let icon = '#' + splitHref[splitHref.length - 1];
            $(obj).attr('xlink:href', icon);
        });
    });

}
